import React from "react";
import BaseListPage from "../../base/BaseListPage";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import withRouter from "../../withRouter";
import LogsPresenter from "./LogsPresenter";
import { InfiniteScroll } from "../../nq-component";
import DateRangeReport from "../../components/DateRangeReport";
import Select from "react-select";
import NavBar from "../../components/navbar";
import LoadingState from "../../components/LoadingState";
import InitialPrompt from "../../components/InitialPrompt";
import Collapsable from "./components/Collapsable";
import PageHeader from "../../components/PageHeader";
import CustomSelect from "../../components/CustomSelect";

class LogsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LogsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: null,
      progress: true,
      currentPage: 1,
      storess: "",
      range: "",
      itemsPerPage: 2000000, // Adjust as needed
      store: [],
      storess: "",
      collapse: null,
    };
  }

  getCollectionName() {
    return "transactions";
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  heads() {
    return (
      <>
        <th style={{ backgroundColor: "#83c14a" }}>Store Code</th>
        <th style={{ backgroundColor: "#83c14a" }}>Total</th>
        <th style={{ backgroundColor: "#83c14a" }}>Status</th>
        <th style={{ backgroundColor: "#83c14a" }}>Re Open</th>
      </>
    );
  }

  onClickCollapse(index) {
    this.setState((prevState) => ({
      collapse: prevState.collapse === index ? null : index,
    }));
  }

  datas() {
    const { currentPage, itemsPerPage, objects, collapse } = this.state;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = objects.slice(indexOfFirstItem, indexOfLastItem);

    const rows = [];

    currentItems.forEach((object, index) => {
      rows.push(
        <tr
          key={index}
          onClick={() => this.onClickCollapse(index)}
          style={{ cursor: "pointer" }}
        >
          <td>{object?.store_code}</td>
          <td>{object?.total}</td>
          <td>{object?.status}</td>
          <td>{object?.reopen}</td>
        </tr>,
      );

      if (collapse === index) {
        rows.push(
          <tr key={`collapse-${index}`}>
            <td colSpan={Object.keys(object).length}>
              <Collapsable object={object} />
            </td>
          </tr>,
        );
      }
    });

    return rows;
  }

  changePage(number) {
    this.setState({ currentPage: number });
  }

  setStore(store) {
    this.setState({ store });
  }

  applyFilters() {
    if (this.state.range && this.state.storess) {
      this.presenter.applyFilters(this.state.range, this.state.storess);
    }
  }

  onChangeDate(range) {
    this.setState({ range }, () => this.applyFilters());
  }

  setNotFound(not) {
    this.setState({ notFound: not });
  }

  onChangeStore(where) {
    this.setState({ storess: where }, () => this.applyFilters());
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  render() {
    return (
      <>
        <NavBar
          action={() => {
            return (
              <div className="dropdown dropstart d-inline-block">
                <i
                  role="button"
                  data-bs-toggle="dropdown"
                  className="bi bi-three-dots-vertical"
                ></i>
                <div className="dropdown-menu  ">
                  <button
                    className="btn w-100 text-white "
                    style={{ backgroundColor: "#64c339", borderRadius: "12px" }}
                    onClick={this.onClickExport.bind(this)}
                  >
                    <i className="fas fa-file-csv me-2"></i> Export CSV
                  </button>
                </div>
              </div>
            );
          }}
        />
        <div className="p-3 p-lg-4">
          {/* <h2 className="fw-bold text-capitalize" style={{ color: "#83c14a" }}>
            Logs
          </h2> */}
          <PageHeader
            title="Void Transactions"
            subtitle="Audit log of all voided sales transactions"
            icon="bi bi-x-octagon-fill"
          />

          <div className="row mb-2 ">
            <div className="col mb-3" style={{ maxWidth: "max-content" }}>
              <DateRangeReport
                onChange={this.onChangeDate.bind(this)}
                field="tran_date"
              />
            </div>
            <div className="col-sm-4">
              {/* <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select Store"
                onChange={(selectedOption) =>
                  this.onChangeStore(selectedOption ? selectedOption.value : "")
                }
                options={[
                  { value: "AllStore", label: "All Store" },
                  ...this.state.store.map((code) => ({
                    value: code.name,
                    label: code.name,
                  })),
                ]}
              /> */}
              <CustomSelect
                label="Store"
                options={[
                  { value: "AllStore", label: "All Store" },
                  ...this.state.store.map((store) => ({
                    value: store.name,
                    label: store.name.replace(/_/g, " "),
                  })),
                ]}
                onChange={(selected) => this.onChangeStore(selected.value)}
                isDisabled={!this.state.range}
                error={
                  !this.state.range ? "Please select a date range first" : ""
                }
                icon="bi bi-shop"
                placeholder="Select Store"
                isClearable={true}
              />
            </div>
          </div>

          <InfiniteScroll>
            <div className="overflow-auto m-auto">
              {(!this.state.range || !this.state.storess) && (
                <InitialPrompt twoFilter={true} />
              )}
              {this.state.storess && (
                <table className="table table-striped table-hover">
                  <thead style={{ backgroundColor: "#83c14a" }}>
                    <tr className="" style={{ backgroundColor: "#83c14a" }}>
                      {this.heads()}
                    </tr>
                  </thead>
                  <tbody>{this.datas()}</tbody>
                </table>
              )}

              {this.state.storess && this.state.objects.length < 1 && (
                <div className="text-center mt-5">
                  <LoadingState />
                </div>
              )}
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(LogsPage);
